module.exports = __webpack_public_path__ + "img/catering_menu_11.7d9eeb4a.jpg";